import cb0 from './carbon_bar_0.png'
import cb1 from './carbon_bar_1.png'
import cb2 from './carbon_bar_2.png'
import cb3 from './carbon_bar_3.png'
import cb4 from './carbon_bar_4.png'
import cb5 from './carbon_bar_5.png'
import cb6 from './carbon_bar_6.png'
import cb7 from './carbon_bar_7.png'
import cb8 from './carbon_bar_8.png'
import cb9 from './carbon_bar_9.png'
import cb10 from './carbon_bar_10.png'
import cb11 from './carbon_bar_11.png'
import cb12 from './carbon_bar_12.png'
import cb13 from './carbon_bar_13.png'
import cb14 from './carbon_bar_14.png'
import cb15 from './carbon_bar_15.png'
import cb16 from './carbon_bar_16.png'
import cb17 from './carbon_bar_17.png'
import cb18 from './carbon_bar_18.png'
import cb19 from './carbon_bar_19.png'
import cb20 from './carbon_bar_20.png'
import cb21 from './carbon_bar_21.png'
import cb22 from './carbon_bar_22.png'
import cb23 from './carbon_bar_23.png'

export const carbonbars = [cb0, cb1, cb2, cb3, cb4, cb5, cb6, cb7, cb8, cb9, cb10, cb11, cb12, cb13, cb14, cb15, cb16, cb17, cb18, cb19, cb20, cb21, cb22, cb23]
